import { AnalyticsProvider } from '@cmpsr/analytics';
import { ComposerProvider } from '@cmpsr/components';
import { QueryClientProvider } from '@tanstack/react-query';
import { theme } from '@ui';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { queryClient } from './client/query';
import { AmplitudeProvider } from './context/me/amplitude.context';
import router from './router';
import { FeatureFlagProvider } from './services/feature-flag-provider';
import injectThemeProps from './services/theme-override.service';

export function App() {
  return (
    <ComposerProvider theme={injectThemeProps(theme)}>
      <QueryClientProvider client={queryClient}>
        {/* Are we getting anything from the AnalyticsProvider anymore? */}
        <AnalyticsProvider>
          <AmplitudeProvider>
            <FeatureFlagProvider>
              <Sentry.ErrorBoundary
                fallback={({ error, resetError }) => (
                  <div className="flex flex-col items-center justify-center min-h-screen p-4">
                    <h1 className="text-2xl font-semibold mb-4">Something went wrong</h1>
                    <p className="text-gray-600 mb-4">
                      {error instanceof Error ? error.message : 'An unexpected error occurred'}
                    </p>
                    <button
                      onClick={resetError}
                      className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                    >
                      Try again
                    </button>
                  </div>
                )}
                showDialog={false}
              >
                <RouterProvider router={createBrowserRouter(router)} />
              </Sentry.ErrorBoundary>
            </FeatureFlagProvider>
          </AmplitudeProvider>
        </AnalyticsProvider>
      </QueryClientProvider>
    </ComposerProvider>
  );
}

export default App;
